import { useLayoutEffect } from "react";

/**
 * After the reveal control unmounts, move focus to the list so keyboard users
 * do not land on document body and can Tab into newly revealed cards.
 */
const useOverflowRevealFocus = (expanded: boolean, listId: string) => {
  useLayoutEffect(() => {
    if (!expanded) {
      return;
    }

    document.getElementById(listId)?.focus({ preventScroll: true });
  }, [expanded, listId]);
};

export { useOverflowRevealFocus };
